import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { motion } from 'framer-motion';
export function Header() {
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} className="sticky top-0 z-50 w-full bg-[#9AC1F0] shadow-lg" data-id="element-85">
      <div className="mx-auto max-w-4xl px-4 py-3 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-86">
        <div className="flex items-center gap-2" data-id="element-87">
          <span className="text-xl" data-id="element-88">🎁</span>
          <span className="font-bold text-white uppercase tracking-wide text-sm sm:text-base" data-id="element-89">
            Holiday Special: Up to 42% Off
          </span>
        </div>

        <CountdownTimer variant="dark" data-id="element-90" />
      </div>

      {/* Progress bar effect */}
      <div className="h-1 w-full bg-blue-700" data-id="element-91">
        <motion.div initial={{
        width: '100%'
      }} animate={{
        width: '0%'
      }} transition={{
        duration: 24 * 60 * 60,
        ease: 'linear'
      }} className="h-full bg-[#FFD700]" data-id="element-92" />
      </div>
    </motion.header>;
}